import React from "react";

import { useServiceList } from "src/organization/pages/project/environment/metrics/profiling/util";
import useGridPoller from "src/organization/pages/project/environment/metrics/resources/grid/useGridPoller";

const timeFrame = { id: "1d", hash: "1d" };

const ResourcesByService = () => {
  const serviceName = useServiceList().serviceList.app[0].name;

  const { status, data, error } = useGridPoller({
    serviceName,
    timeFrame
  });

  return (
    <React.Fragment>
      {data && <pre>{JSON.stringify(data, null, "  ")}</pre>}
      {status.refresh && <pre>LOADING</pre>}
      {!!error && (
        <pre>
          <code>
            🚨 Error while fetching resources data {JSON.stringify(error)} 🚨
          </code>
        </pre>
      )}
    </React.Fragment>
  );
};

export default ResourcesByService;
